import { render } from "./candidates-board.vue?vue&type=template&id=8333e97c"
import script from "./candidates-board.vue?vue&type=script&lang=js"
export * from "./candidates-board.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__